$(document).ready(function(){
    var CELL_PHONE_FORMAT = django.formats.CELL_PHONE_FORMAT;
    if(CELL_PHONE_FORMAT){
        $(".cellphone-masked").each(function(i, element){
            IMask(
              element, {
                mask: CELL_PHONE_FORMAT
              });
        });
    }
});